import {
  IDocumentType,
  IAdvancedSearchCriterion,
  IJournalMember,
  IOrganization,
  IWorkspaceMembership,
  IRoleConfig,
  ISubmissionContext,
  IArticleType,
  IRoleAssignment,
  IMetadataExtractionResponse,
  ISubmissionDraft,
  ISubmission,
  ISubmissionFile,
  ISubmissionWorkflowState,
  IFormDraftEntityType,
  IRoleType,
  IReviewerInvitation,
  ITags,
  ISavedFilters,
  IUser,
  IInvitedUserListResponse,
  IUserListResponse,
  IUserRolesResponse,
  IBoardMemberItem,
  ICopyrightForm,
  IContentManagementSystem,
  IEditorialFormSchema,
  IReviewerEligibility,
  IAdjudicatorFeedback,
  INoteCategory,
  IAuthorCopyrightForm,
  IWorkspace,
  ITitlePageExtractedResponse,
  IAuthorICMJEForm,
  IAuthorICMJEFormList,
  IAdjudicatorEligibility,
  IIntegrityOverviewResponse,
  ICustomChecksResponse,
  SubmissionVersionLogResponse,
  IManuscriptOverviewResponse,
  IReviewerAccountBodyParams,
  IUADReportResponse,
  ISubmissionParticipantsResponse,
  IPeerReviewHighlightsCountsResponse,
  IUserProfileAuditLogResponse,
  ILexiconField,
  IReviewerSuggestion,
  RecommendationProvider,
  IPageHelpContent,
  IGetTopicResponse,
  IGetVideoResponse,
  IPageHelpContentResponse,
  IMySubmissionsTotals
} from '@publishing-engine/domain/models';
import {
  IPeerReviewManagementListView,
  IPeerReviewManagementView,
  ISubmissionManagementListView,
  ISubmissionContextListView,
  ISubmissionNotesManagementListView,
  IBlockedReviewerListView,
  IJournalInfo,
  IEarlyAssessmentListItem,
  IAdjudicationListItem,
  IMyReviewsResponse,
  IReviewerCOI,
  IReviewerCOIItem,
  ISubmissionListItem
} from '@publishing-engine/domain/views';
import axiosInstance from './client';
import { IFormSchema } from '@publishing-engine/domain/models/form-schema';
import { generateId, IAuthRealm } from '@publishing-engine/domain/utils';
import { ITransitionGraph } from '../../../domain/models/transition-graph';
import {
  IFormSchemaName,
  IIncompleteArticleWorkflow
} from '@publishing-engine/domain/models/article-workflow';
import {
  GetActiveRevisionRoute,
  GetReviewsSummaryRoute,
  GetSubmittedReviewersRoute,
  GetRevisionHistoryRoute,
  GetSubmissionExtensionDeadlineRoute,
  GetSubmissionFieldsRoute,
  TransferNetworkConfigRoute,
  IGetActiveRevisionResponse,
  IGetArticleWorkflowResponse,
  IGetExtensionDeadlineResponse,
  IGetReviewsSummaryResponse,
  IGetSubmittedReviewersResponse,
  IGetRevisionHistoryResponse,
  IGetSubmissionContextPhasesResponse,
  IGetSubmissionContextRoleAssignmentsResponse,
  IGetSubmissionEditorialAssigneesResponse,
  IGetSubmissionFeedbackResponse,
  IGetSubmissionFieldsResponse,
  IGetSubmissionWorkflowResponse,
  IGetTransferNetworkConfigResponse,
  IWorkspaceSubmissionsRouteResponse,
  IWorkspaceSubmissionsFiltersRouteResponse,
  WorkspaceSubmissionNextRoute,
  IGetArticleWorkflowSubmissionStatesResponse,
  ArticleWorkflowSubmissionStatesRoute,
  IGetSubmissionTransferNetworkResponse,
  SubmissionTransferNetworkRoute,
  IGetTransferOfferResponse,
  GetTransferOfferRoute,
  MySubmissionsFilters,
  IGetMissingFieldsFromArticleIdResponse,
  GetMissingFieldsFromArticleIdRoute,
  FocusIssues,
  FormDraftRoute,
  IGetFormDraftResponse,
  IGetSubmissionRejectionResponse,
  SubmissionRejectionRoute,
  SubmissionChangeRequestRoute,
  IGetSubmissionChangeRequestResponse,
  UsersSearchRoute,
  UsersSearchResponse,
  UsersListRoute,
  UsersListResponse,
  JournalsSearchResponse,
  JournalsSearchRoute,
  IGetSubmissionWithdrawalResponse,
  SubmissionWithdrawalRoute,
  SubmissionRequestedChanges,
  IGetSubmissionUnsubmitResponse,
  SubmissionUnsubmitRoute,
  GetOrganizationNameRoute,
  SubmissionCopyrightFormRoute,
  GetSubmissionContextCMSRoute,
  HasOwnedSubmissionInWorkspaceRoute,
  WorkspaceMembershipRoute,
  IGetWorkspaceMembershipResponse,
  ChecklistRoute,
  IChecklistResponse,
  MyJournalMembershipRoute,
  JournalMembershipRoute,
  UnassignedJournalMembershipRoute,
  EventEmailsRoute,
  GetAdjudicationsSummaryRoute,
  SubmissionArticleTypesCompatibilityRoute,
  ISubmissionArticleTypesCompatibilityRouteResponse,
  SubmittingAuthorOnlyCopyrightFormRoute,
  SubmissionAuthorICMJEFormRoute,
  IMyWorkspacesRouteResponse,
  MyWorkspacesRoute,
  WorkspaceMergeAccountSearchFieldsRoute,
  WorkspaceMergeAccountSearchRoute,
  WorkspaceMembershipsRoute,
  WorkspaceByShortnameRoute,
  WorkspaceSubmissionsFiltersRoute,
  WorkspaceSubmissionsRoute,
  WorkspaceRolesRoute,
  OrganizationArticleTypesRoute,
  SubmissionContextTagsRoute,
  WorkspaceTagsRoute,
  WorkspaceTagRoute,
  WorkspaceSavedFiltersRoute,
  WorkspaceJournalsRoute,
  UserOrganizationWorkspacesRoute,
  IUserOrganizationWorkspacesResponse,
  WorkspaceEditorialPhasesRoute,
  SubmissionEditorSendCopyrightFormEmailRoute,
  HasCompletedReviewsRoute,
  SubmissionEditorSendICMJEFormEmailRoute,
  WorkspaceWorkflowResponse,
  IGetSubmissionRecommendationAssigneesResponse,
  SubmissionAuthorICMJEFormListRoute,
  SubmissionAuthorSubmitAllICMJEFormRoute,
  AdjudicatorEligibilityRoute,
  SubmissionEditorDownloadICMJEFormsRoute,
  IGetCOCRecommedationSummaryResponse,
  AuthRealmJournalsRoute,
  VendorExportConnectionTest,
  MySubmissionsTotalRoute,
  ITotalSubmissionsResponse,
  IGetPreProductionFeedbackResponse,
  ContactUsConfigRoute,
  ContactUsUnauthenticatedConfigRoute,
  INotesHistoryResponse,
  JournalConfigurationBucketsRoute,
  JournalConfigurationDecisionTemplatesRoute,
  SubmissionDecisionTemplatesByTypeRoute,
  WorkflowBucket,
  JournalConfigurationDefaultBucketsRoute,
  JournalConfigurationDefaultDecisionTemplateOptionsRoute,
  JournalConfigurationArticleChecklistRoute,
  PageHelpCreateRoute,
  PageHelpTopicRoute,
  PageHelpRoute,
  PageHelpPlayVideoRoute,
  DashboardMySubmissionsTotalsRoute
} from '@publishing-engine/submission-service/src/endpoints/api.response-types';
import {
  IAdjudicationsDashBoardConfigResponse,
  IAssessmentDashBoardConfigResponse,
  IDashboardSubmissionConfigResponse,
  ISubmissionEventParams
} from '@publishing-engine/domain/types';
import {
  IAuthor,
  IPublicationHistoryDataType,
  IAuthorReviewType,
  IReviewerActivity
} from '@publishing-engine/domain/types/AuthorType';

import {
  IAssessmentFilterStatus,
  IEarlyAssessmentListFilters,
  IEarlyAssessmentListFiltersResponse
} from 'src/pages/MyTask/Assessments/hooks';
import { IDecisionTemplatesByTypeResponse } from '@publishing-engine/domain/models';
import {
  IAdjudicationDetailResponse,
  IAdjudicationReview
} from 'src/pages/MyTask/Adjudications/adjudicationType';
import { centralAuthUrl } from 'src/utils/env';
import axiosInstanceBaseAuth from './clientBasic';
import { IPastRevisionHistoryResponse } from 'src/pages/Review/PastReviewTab';
import { EmailHistory } from '@publishing-engine/domain/models/email-templates';
import {
  IAdjudicationsListFilters,
  IAdjudicationsListFiltersResponse
} from 'src/pages/MyTask/Adjudications/hooks';
import { IUserDetailsResponse } from './signUpMutation';
import {
  IVendorExportConnTestResponse,
  IVendorHistoryResponse,
  VendorExportFilters
} from '@publishing-engine/domain/models/vendor-exports';
import {
  IEmailLog,
  IEmailLogResponse
} from '@publishing-engine/domain/types/email-template';
import { ReportConfig } from '@publishing-engine/domain/actions/v1/reports';
import { ITagCategoryList } from 'src/pages/Organization/Workspace/Settings/ManageTags/ManageTagCategories';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';

export type IListResponse<T> = {
  total: number;
  collection: T[];
};

export type IWorkspaceSubmissionFilter = {
  workflowPhase: ISubmissionWorkflowState[];
  journalId: string[];
  documentType: IDocumentType[];
  assigneeId: string[];
  tagId: string[];
  searchParams: string;
  focusIssueId: string[];
  userTags?: string[];
  expertPhases?: string[];
  advancedSearch?: IAdvancedSearchCriterion[];
  [key: string]: any;
};

export type IWorkspaceEmailTemplatesFilter = {
  event: string[];
  scope: string[];
  categories: string[];
  status: string[];
  searchParams: string;
};

export type IWorkspaceUserFilter = {
  journalId: string[];
  tagId: string[];
  role: string[];
  searchParams: string;
  /**
   * The users view names its advanced-search criteria `searchFields` (the
   * submissions view calls them `advancedSearch`).
   */
  searchFields?: IAdvancedSearchCriterion[];
};

export type IMergeAccountSearchFilter = {
  firstName?: string[];
  lastName?: string[];
  email?: string[];
  orcid?: string[];
  affiliation?: string[];
  duplicateBy?: 'fullName' | 'email' | 'orcid' | 'affiliation' | 'emptyOrcid';
};

export type IMergeAccountSearchField = {
  label: string;
  value: Exclude<keyof IMergeAccountSearchFilter, 'duplicateBy'>;
};

export type IWorkspaceMembershipFilter = {
  searchParams: string;
};

export type IProcessedWebhookEventsQuery = {
  limit?: number;
  page?: number;
  email?: string;
  search?: string;
  eventTypes?: string[] | string;
  reason?: string[] | string;
  status?: string[] | string;
  submissionContextId?: string[] | string;
  sort?: ISubmissionSortOption;
};

export interface IEmailHistoryListQuery {
  limit?: number;
  offset?: number;
  email?: string;
  search?: string;
  submissionContextId?: string[];
  eventNames?: string[];
  sort?: {
    value: string;
    label?: string;
    direction: 'asc' | 'desc';
  };
}

export interface IEmailHistoryItem {
  _id: string;
  organizationId?: string;
  eventId?: string;
  templateId?: string;
  submissionId?: string;
  submissionContextId?: string;
  subject?: string;
  body?: string;
  recipients?: {
    to?: string[];
    cc?: string[];
    bcc?: string[];
  };
  attachments?: any[];
  sendingSuccess: boolean;
  trackerId?: string;
  eventName?: string;
  createdAt: string;
  updatedAt?: string;
  manuscriptId?: string;
}

export type IEmailHistoryListResponse = {
  data: IEmailHistoryItem[];
  total: number;
};

export interface ITemplateInfo {
  _id: string;
  templateId: string;
  name: string;
  event: string;
  subject: string;
  active: boolean;
  scope: string;
  category: string;
  description: string;
}

export interface IWebhookEventData {
  reason: string | null;
  originalReason: string | null;
  status: string;
  response: string;
  attemptCount: number;
  smtpId: string;
  url: string;
  userAgent: string;
  bounceType: string;
}

export interface IWebhookEventMetadata {
  category: string[];
  customArgs: Record<string, any>;
}

export interface IWebhookEvent {
  _id: string;
  eventType: string;
  email: string;
  timestamp: string;
  eventData: IWebhookEventData;
  metadata: IWebhookEventMetadata;
  sg_event_id: string;
  sg_message_id: string;
  trackerId: string;
  eventId: string;
  isRetryDone: boolean;
  parent: boolean;
}
export interface IEmailTrackerData extends IEmailHistoryItem {
  template?: ITemplateInfo;
  webhookEvents: IWebhookEvent[];
}
export interface IEmailTrackerResponse {
  data: IEmailTrackerData;
}

export type IProcessedWebhookEvent = {
  _id: string;
  sequenceId: string;
  eventType: string;
  email: string;
  timestamp: string;
  trackerId?: string;
  sg_event_id: string;
  sg_message_id: string;
  emailDetail?: {
    type?: string;
    subType?: string;
    manuscriptId?: string;
    subject?: string;
    body?: string;
    recipients?: {
      to?: string[];
      cc?: string[];
      bcc?: string[];
    };
    submissionId?: string;
    submissionContextId?: string;
    retryCount?: number;
    trackerId?: string;
    isRetryDone?: boolean;
  };
  isRetryDone?: boolean;
  eventData: {
    reason?: string;
    status?: string;
    response?: string;
    attemptCount?: number;
    smtpId?: string;
    url?: string;
    userAgent?: string;
    [key: string]: unknown;
  };
  metadata: {
    ip?: string;
    userAgent?: string;
    category?: string[];
    asmGroupId?: number;
    customArgs?: Record<string, unknown>;
  };
  rawPayload?: unknown;
  createdAt?: string;
  updatedAt?: string;
};

export type IProcessedWebhookEventsResponse = {
  total: number;
  items: IProcessedWebhookEvent[];
  page: number;
  limit: number;
};

export type IProcessedWebhookEventDetailsResponse = {
  webhook: IProcessedWebhookEvent;
  sisterWebhooks: IProcessedWebhookEvent[];
  manuscriptId?: string;
  emailDetails?: {
    body?: string;
    subject?: string;
    recipients?: {
      to?: string[];
      cc?: string[];
      bcc?: string[];
    };
  };
};

export type IMySubmissionFilter = {
  workflowPhase: ISubmissionWorkflowState[];
  journalId: string[];
  searchParams: string;
  submissionType?:
    | 'my-submissions-active'
    | 'my-submissions-draft'
    | 'my-submissions-revision'
    | 'my-submissions-unsubmitted'
    | 'my-submissions-completed';
};

export function health() {
  return axiosInstance.get<unknown>('/health').then(res => res.data);
}

export function fetchOrganization(shortname: string) {
  return axiosInstance
    .get<IOrganization>(`/organizations/${shortname}`)
    .then(r => r.data);
}

export function fetchWorkspaceByShortname(shortname: string) {
  return axiosInstance
    .get<Pick<IWorkspace, 'id' | 'organizationId' | 'featureConfig'>>(
      WorkspaceByShortnameRoute.build({ shortname })
    )
    .then(r => r.data);
}

export function checkUser(email: string) {
  return axiosInstance.get('/user/' + email).then(r => r.data);
}

type IEnsureUserResponse = {
  email: string;
  message: string;
  userId: string;
  status: IUser['status'];
};
export function ensureUser(email: string) {
  return axiosInstance
    .post<IEnsureUserResponse>(`/users/ensure`, { email })
    .then(r => r.data);
}

export function ensureAllUsers(emails: string[]) {
  return axiosInstance
    .post<{ users: IEnsureUserResponse[] }>(`/users/ensure-all`, { emails })
    .then(r => r.data.users);
}

export function createReviewerAccount(body: IReviewerAccountBodyParams) {
  return axiosInstance
    .post('/users/ensure?isReviewer=' + true, body)
    .then(r => r.data);
}

export function syncUser({
  sub,
  email,
  family_name,
  given_name,
  affiliation,
  orcid,
  ringgold_id,
  idp,
  affiliation_country,
  affiliation_location,
  salutation,
  auth_time
}: {
  sub: string;
  email: string;
  family_name: string;
  given_name: string;
  affiliation: string;
  orcid: string;
  ringgold_id: string;
  idp: string;
  affiliation_country: string;
  affiliation_location: string;
  salutation: string;
  auth_time?: number;
}) {
  return axiosInstance
    .post(`/users/sync`, {
      sub,
      email,
      family_name,
      given_name,
      affiliation,
      orcid,
      ringgold_id,
      idp,
      affiliation_country,
      affiliation_location,
      salutation,
      auth_time
    })
    .then(r => r.data);
}

export function recordLogin(auth_time?: number) {
  return axiosInstance
    .post(`/users/record-login`, { auth_time })
    .then(r => r.data);
}

export function impersonateUser(userId: string, realm: string) {
  return axiosInstanceBaseAuth
    .post<any>(
      `${centralAuthUrl}/admin/realms/${realm}/users/${userId}/impersonation`,
      {},
      { withCredentials: true }
    )
    .then(r => r.data);
}

export function fetchExtractedSubmissionMetadata(
  submissionId: string,
  submissionContextId: string,
  fileUrl: string
) {
  const idempotencyId = generateId();
  return axiosInstance
    .post<IMetadataExtractionResponse>(
      '/integrations/metadata-extraction/manuscript-extract',
      {
        idempotency_id: idempotencyId,
        submission_id: submissionId,
        submission_context_id: submissionContextId,
        file_url: fileUrl
      }
    )
    .then(r => r.data);
}

export function fetchExtractedTitlePageMetadata(
  submissionId: string,
  submissionContextId: string,
  fileUrl: string
) {
  const idempotencyId = generateId();
  return axiosInstance
    .post<ITitlePageExtractedResponse>(
      'integrations/document-extraction/document-extract',
      {
        idempotency_id: idempotencyId,
        submission_id: submissionId,
        submission_context_id: submissionContextId,
        file_url: fileUrl
      }
    )
    .then(r => r.data);
}

export function fetchSuggestedKeywords(
  submissionId: string,
  submissionContextId: string,
  title: string,
  abstract: string
) {
  return axiosInstance
    .post<{
      results: string[];
    }>(
      `submission-contexts/${submissionContextId}/submissions/${submissionId}/suggest-keywords`,
      { title, abstract }
    )
    .then(r => r.data.results);
}

export function fetchOrganizationJournals(
  shortname: string,
  offset?: number,
  limit?: number
) {
  return axiosInstance
    .get<ISubmissionContextListView>(`/organizations/${shortname}/journals`, {
      params: {
        limit,
        offset
      }
    })
    .then(r => r.data);
}

export function fetchAuthRealmJournals(
  authRealm: IAuthRealm,
  offset?: number,
  limit?: number,
  searchParams?: string
) {
  return axiosInstance
    .get<ISubmissionContextListView>(
      AuthRealmJournalsRoute.build({ id: authRealm }),
      {
        params: {
          limit,
          offset,
          searchParams
        }
      }
    )
    .then(r => r.data);
}

export function fetchWorkspaceJournals(
  workspaceId: string,
  offset?: number,
  limit?: number,
  searchParams?: string
) {
  return axiosInstance
    .get<ISubmissionContextListView>(
      WorkspaceJournalsRoute.build({ id: workspaceId }),
      {
        params: {
          limit,
          offset,
          ...(searchParams?.trim() ? { searchParams: searchParams.trim() } : {})
        }
      }
    )
    .then(r => r.data);
}

export function fetchReportsConfigData(workspaceId: string) {
  return axiosInstance
    .get<ReportConfig[]>(`/workspace/${workspaceId}/reports/configs`)
    .then(r => r.data);
}

export type WorkspaceAnalyticsConfigOption = {
  label: string;
  value: string;
};

export type WorkspaceAnalyticsRequestField = {
  name: string;
  key: string;
  type: string;
  required: boolean;
  optionsSource?: string;
  options?: WorkspaceAnalyticsConfigOption[];
};

export type WorkspaceAnalyticsChartConfig = {
  id: string;
  name: string;
  chartType: string;
  axes?: {
    x?: string;
    y?: string;
  };
};

export type WorkspaceAnalyticsTabConfig = {
  id: string;
  tabName: string;
  description?: string;
  roles?: string[];
  requestSchema?: WorkspaceAnalyticsRequestField[];
  charts?: WorkspaceAnalyticsChartConfig[];
};

export type WorkspaceAnalyticsConfigResponse =
  | WorkspaceAnalyticsTabConfig
  | WorkspaceAnalyticsTabConfig[];

export function fetchWorkspaceAnalyticsConfigs(workspaceId: string) {
  return axiosInstance
    .get<WorkspaceAnalyticsConfigResponse>(
      `/workspace/${workspaceId}/analytics/configs`
    )
    .then(r => r.data);
}

export function fetchContextSubmissions(submissionContextId: string) {
  return axiosInstance
    .get<ISubmissionManagementListView>(
      `submission-contexts/${submissionContextId}/submissions`,
      { params: { roleContext: 'editor' } }
    )
    .then(r => r.data);
}

export function fetchWorkspaceSubmissions({
  workspaceId,
  limit,
  offset,
  filters,
  sort
}: {
  workspaceId: string;
  limit?: number;
  offset?: number;
  filters?: IWorkspaceSubmissionFilter;
  sort?: ISubmissionSortOption;
}) {
  return axiosInstance
    .get<IWorkspaceSubmissionsRouteResponse['response']>(
      WorkspaceSubmissionsRoute.build({ id: workspaceId }),
      {
        params: {
          limit,
          offset,
          filters: JSON.stringify(filters ?? {}),
          ...(sort && { sort: JSON.stringify(sort) })
        }
      }
    )
    .then(r => r.data);
}

/**
 * Response of `WorkspaceSubmissionNextRoute`. Unlike the submissions list route,
 * this handler wraps its payload in a `{ success, data }` envelope, and the
 * service package does not export a type for it.
 */
export type IWorkspaceSubmissionNextRouteResponse = {
  response: {
    success: boolean;
    data: {
      total: number;
      currentGlobalIndex: number | null;
      nextGlobalIndex: number | null;
      nextItem: ISubmissionListItem | null;
      nextOffset: number;
      nextLimit: number;
      needsPageChange: boolean;
      submissionWasDeleted?: boolean;
    };
  };
};

export function fetchNextWorkspaceSubmission({
  workspaceId,
  submissionId,
  index,
  offset,
  limit,
  filters,
  sort
}: {
  workspaceId: string;
  submissionId: string;
  index: number;
  offset: number;
  limit: number;
  filters: IWorkspaceSubmissionFilter;
  sort?: ISubmissionSortOption | null;
}) {
  return axiosInstance
    .get<IWorkspaceSubmissionNextRouteResponse['response']>(
      WorkspaceSubmissionNextRoute.build({ id: workspaceId }),
      {
        params: {
          submissionId,
          index,
          offset,
          limit,
          filters: JSON.stringify(filters ?? {}),
          ...(sort && { sort: JSON.stringify(sort) })
        }
      }
    )
    .then(r => r.data);
}

export function fetchWorkspaceSubmissionFilters(workspaceId: string) {
  return axiosInstance
    .get<IWorkspaceSubmissionsFiltersRouteResponse['response']>(
      WorkspaceSubmissionsFiltersRoute.build({ id: workspaceId })
    )
    .then(r => r.data);
}

export const fetchDraftSubmissionById = (
  submissionContextId: string,
  submissionId: string
) =>
  axiosInstance
    .get<ISubmissionDraft>(
      `submission-contexts/${submissionContextId}/submissions/${submissionId}/draft`
    )
    .then(r => r.data);

// TODO: fix endpoint url and data shape
export function fetchMySubmissions({
  limit,
  offset,
  filters
}: {
  limit?: number;
  offset?: number;
  filters?: IMySubmissionFilter;
}) {
  return axiosInstance
    .get<
      ISubmissionManagementListView & {
        drafts: (ISubmissionDraft & IJournalInfo)[];
      }
    >('/my-submissions', {
      params: {
        limit,
        offset,
        filters: JSON.stringify(filters ?? {})
      }
    })
    .then(r => r.data);
}

export function fetchSubmissionReviews(
  submissionContextId: string,
  submissionId: string,
  isRevisionRound: boolean = false,
  offset: number = 0,
  limit: number = 10,
  searchParams?: string,
  status?: string[],
  sort?: ISubmissionSortOption
) {
  return axiosInstance
    .get<IPeerReviewManagementListView>(
      `submission-contexts/${submissionContextId}/reviews`,
      {
        params: {
          submissionId,
          roleContext: 'editor',
          isRevisionRound,
          offset,
          limit,
          searchParams,
          status: status?.length ? JSON.stringify(status) : undefined,
          ...(sort && { sort: JSON.stringify(sort) })
        }
      }
    )
    .then(r => r.data);
}

export function fetchBlockedReviewers(
  submissionContextId: string,
  submissionId: string
) {
  return axiosInstance
    .get<IBlockedReviewerListView>(
      `submission-contexts/${submissionContextId}/reviews/block-list`,
      {
        params: {
          submissionId,
          roleContext: 'editor'
        }
      }
    )
    .then(r => r.data);
}

export type IReviewerInvitationResponse = IReviewerInvitation & {
  userDetails?: IUser[];
};
export function fetchEnqueuedReviewers(
  submissionContextId: string,
  submissionId: string
) {
  return axiosInstance
    .get<IReviewerInvitationResponse>(
      `submission-contexts/${submissionContextId}/enqueued-reviewers`,
      { params: { submissionId } }
    )
    .then(r => r.data);
}

export type IMyReviewsFilters = {
  journalId: string[];
  searchParams: string;
  reviewListType?: 'active' | 'completed';
};
export function fetchMyReviews(
  reviewListType: 'active' | 'completed',
  offset: number,
  limit: number,
  filters: IMyReviewsFilters,
  sort?: ISubmissionSortOption
) {
  return axiosInstance
    .get<IMyReviewsResponse>(`/reviews`, {
      params: {
        reviewListType,
        offset,
        limit,
        filters: JSON.stringify(filters ?? {}),
        ...(sort && { sort: JSON.stringify(sort) })
      }
    })
    .then(r => r.data);
}

export function fetchMyReviewsTotals() {
  return axiosInstance
    .get<{ activeTotal: number; completedTotal: number }>(`/reviews/totals`)
    .then(r => r.data);
}

export function fetchReview(reviewId: string, roleContext = 'reviewer') {
  return axiosInstance
    .get<IPeerReviewManagementView>(`reviews/${reviewId}`, {
      params: { roleContext }
    })
    .then(r => r.data);
}

export function fetchSubmissionNotes({
  ctxId,
  submissionId,
  offset = 0,
  limit,
  category,
  sort,
  filters
}: {
  ctxId: string;
  submissionId: string;
  offset?: number;
  limit?: number;
  category: INoteCategory[];
  sort?: { value: string; direction: 'asc' | 'desc' };
  filters?: { searchParams?: string };
}) {
  return axiosInstance
    .get<ISubmissionNotesManagementListView>(
      `submission-contexts/${ctxId}/notes`,
      {
        params: {
          roleContext: 'editor',
          submissionId,
          offset,
          limit,
          category: category.join(','),
          sort: JSON.stringify(sort ?? {}),
          filters: JSON.stringify(filters ?? {})
        }
      }
    )
    .then(r => r.data);
}

export function fetchSubmissionNotesHistory({
  ctxId,
  submissionId
}: {
  ctxId: string;
  submissionId: string;
}) {
  return axiosInstance
    .get<INotesHistoryResponse>(`submission-contexts/${ctxId}/notes/history`, {
      params: {
        roleContext: 'editor',
        submissionId
      }
    })
    .then(r => r.data);
}

export function getSignedPrivateUploadUrl(
  submissionId: string,
  extension: string
) {
  return axiosInstance
    .get<{ signed_url: string; file_url: string }>(
      `submission/${submissionId}/upload-signed-url`,
      {
        params: {
          extension,
          fileMetadataStrip: true
        }
      }
    )
    .then(r => r.data);
}

export function getOrganizationSignedPrivateUploadUrl(
  organizationId: string,
  extension: string,
  isPrivate: boolean
) {
  return axiosInstance
    .get<{ signed_url: string; file_url: string }>(
      `organization/${organizationId}/upload-signed-url`,
      {
        params: {
          extension,
          isPrivate,
          fileMetadataStrip: true
        }
      }
    )
    .then(r => r.data);
}

export function getOrganizationSignedPrivateAccessUrl(
  organizationId: string,
  url: string
) {
  // temp fix for the existing assets, the new ones will be at `morressier-private-assets-staging`
  if (url.includes('morressier-assets-')) {
    return Promise.resolve(url);
  }

  return axiosInstance
    .get<string>(`organization/${organizationId}/asset-access`, {
      params: {
        url
      }
    })
    .then(r => r.data);
}

export function getSignedPrivateAccessUrl(submissionId: string, url: string) {
  // temp fix for the existing assets, the new ones will be at `morressier-private-assets-staging`
  if (url.includes('morressier-assets-')) {
    return Promise.resolve(url);
  }

  return axiosInstance
    .get<string>(`submission/${submissionId}/asset-access`, {
      params: {
        url
      }
    })
    .then(r => r.data);
}

export function deleteUploadedFile(id: string) {
  return axiosInstance.delete(`/asset/${id}`);
}

export type IFetchOrganizationAndJournalsInfo = {
  organization: Pick<IOrganization, 'name' | 'shortname'>;
  journals: Pick<ISubmissionContext, 'data' | 'id'>[];
};
export const fetchOrganizationAndJournalsInformation = async (
  organizationId: string
) => {
  return axiosInstance
    .get<IFetchOrganizationAndJournalsInfo>(
      `organizations/${organizationId}/name-and-journals`
    )
    .then(r => r.data);
};

export type IFetchSubmissionContext = ISubmissionContext & {
  workflow: { transitionGraph: ITransitionGraph };
  articleTypes: {
    articleTypeCategoryId: string;
    articleWorkflowId: string;
    name: string;
    description: string;
    formSchemas: {
      authorSubmission: string;
      editorRevisionRequest: string;
      authorRevision: string;
      reviewerFirstAssessment: string;
      reviewerRevisionAssessment: string;
    };
  }[];
};

export function fetchSubmissionContext(contextId: string) {
  return axiosInstance
    .get<IFetchSubmissionContext>(`submission-contexts/${contextId}`)
    .then(r => r.data);
}

export function fetchConsolidatedPdfStatus(
  submissionContextId: string,
  submissionId: string
) {
  return axiosInstance
    .get<{
      status: 'not-started' | 'processing' | 'completed' | 'failed';
      error?: string;
      file?: ISubmissionFile;
      anonymizedFile?: ISubmissionFile;
    }>(
      `submission-contexts/${submissionContextId}/submissions/${submissionId}/draft/consolidated-pdf/status`
    )
    .then(r => r.data);
}

export function fetchRevisionConsolidatedPdfStatus(
  submissionContextId: string,
  submissionId: string
) {
  return axiosInstance
    .get<{
      status: 'not-started' | 'processing' | 'completed' | 'failed';
      error?: string;
      file?: ISubmissionFile;
      anonymizedFile?: ISubmissionFile;
    }>(
      `submission-contexts/${submissionContextId}/submissions/${submissionId}/revision/consolidated-pdf/status`
    )
    .then(r => r.data);
}

export function fetchFormSchema(contextId: string, schemaId: string) {
  return axiosInstance
    .get<{
      documentSchema: IFormSchema;
    }>(`submission-contexts/${contextId}/document-schemas/${schemaId}`)
    .then(r => r.data);
}

export function fetchSubmissionContexts() {
  return axiosInstance
    .get<{ collection: ISubmissionContext[] }>(`submission-contexts`)
    .then(r => r.data);
}

export function fetchSubmissionExportUrl(
  submissionId: string,
  submissionContextId: string
) {
  return axiosInstance
    .get<string>(
      `submission-contexts/${submissionContextId}/submissions/${submissionId}/export-url`
    )
    .then(r => r.data);
}

export const fetchExportSubmissionUrl = async (submissionId: string) => {
  return axiosInstance
    .get<Blob>(`submission/${submissionId}/preprod/export`, {
      responseType: 'blob'
    })
    .then(r => r.data);
};

export function fetchArticleWorkflowById(
  articleWorkflowId: string,
  inlineForms: boolean = true
) {
  return axiosInstance
    .get<IGetArticleWorkflowResponse>(`article-workflow/${articleWorkflowId}`, {
      params: { inlineForms }
    })
    .then(r => r.data);
}

export function fetchArticleWorkflowBySubmissionId(
  submissionId: string,
  submissionContextId: string
) {
  return axiosInstance
    .get<{
      article_workflow: Pick<
        IIncompleteArticleWorkflow,
        | 'id'
        | 'articleTypeCategoryId'
        | 'formSchemas'
        | 'transitionGraph'
        | 'organizationId'
      >;
    }>(
      `submission-contexts/${submissionContextId}/submissions/${submissionId}/article-workflow`
    )
    .then(r => r.data);
}

export function getAuthAccess({
  relation,
  entityType,
  entityId
}: {
  relation: string;
  entityType: string;
  entityId: string;
}) {
  return axiosInstance
    .post(`/auth/check`, {
      relation,
      entityType,
      entityId
    })
    .then(r => r.data.allowed);
}

export function fetchUserWorkspaces() {
  return axiosInstance
    .get<IMyWorkspacesRouteResponse>(MyWorkspacesRoute.build({}))
    .then(r => r.data);
}

export function fetchWorkspaceRoles(workspaceId: string) {
  return axiosInstance
    .get<{
      roleConfigs: IRoleConfig;
      roleDisplayNames?: Record<string, string>;
      id?: string;
    }>(WorkspaceRolesRoute.build({ id: workspaceId }))
    .then(r => r.data);
}

export function fetchUserSubmissionsTotals({
  authRealm,
  userId
}: {
  authRealm: string;
  userId: string;
}) {
  return axiosInstance
    .get<ITotalSubmissionsResponse>(
      MySubmissionsTotalRoute.build({ authRealm, userId })
    )
    .then(r => r.data);
}

export function fetchWorkspaceEditorialPhases(workspaceId: string) {
  return axiosInstance
    .get<IGetSubmissionContextPhasesResponse>(
      WorkspaceEditorialPhasesRoute.build({ id: workspaceId })
    )
    .then(r => r.data);
}

export function fetchOrgArticleTypes(orgId: string) {
  return axiosInstance
    .get<{
      items: IArticleType[];
    }>(OrganizationArticleTypesRoute.build({ id: orgId }))
    .then(r => r.data);
}

export function fetchWorkspaceTags(
  workspaceId: string,
  filter: string = '',
  offset: number = 0,
  limit: number = 999
) {
  return axiosInstance
    .get<{ collection: ITags[]; total: number }>(
      `${WorkspaceTagsRoute.build({
        id: workspaceId
      })}?offset=${offset}&limit=${limit}&usage=${filter}`
    )
    .then(r => r.data);
}

export function fetchSubmissionContextTags(
  submissionContextId: string,
  filter: string = '',
  offset: number = 0,
  limit: number = 999
) {
  return axiosInstance
    .get<{ collection: ITags[]; total: number }>(
      `${SubmissionContextTagsRoute.build({
        ctxId: submissionContextId
      })}?offset=${offset}&limit=${limit}&usage=${filter}`
    )
    .then(r => r.data);
}

export function fetchEditorTags(submissionId: string) {
  return axiosInstance
    .get<{ response: ITags[] }>(`/submissions/${submissionId}/tags`)
    .then(r => r.data);
}

export function fetchSubmissionFilters(workspaceId: string) {
  return axiosInstance
    .get<{
      response: ISavedFilters[];
    }>(WorkspaceSavedFiltersRoute.build({ id: workspaceId }))
    .then(r => r.data);
}

export function fetchSubmissionContextArticleTypes(
  submissionContextId: string
) {
  return axiosInstance
    .get<{
      articleTypes: { name: string; id: string; documentSchemaId: string }[];
    }>(`/submission-contexts/${submissionContextId}/article-types`)
    .then(r => r.data);
}

export function fetchAvailableArticleTypes(submissionContextId: string) {
  return axiosInstance
    .get<{
      articleTypes: { id: string; name: string; description: string }[];
    }>(`/submission-contexts/${submissionContextId}/article-types/available`)
    .then(r => r.data);
}

export function fetchSubmissionContextMemberships(
  contextId: string,
  params: { limit?: number; offset?: number } = {}
) {
  return axiosInstance
    .get<{ collection: IJournalMember[]; total: number }>(
      JournalMembershipRoute.build({ ctxId: contextId }),
      {
        params: {
          limit: params.limit || 10,
          offset: params.offset || 0
        }
      }
    )
    .then(r => r.data);
}

export function fetchMyRoleInSubmissionContext(contextId: string) {
  return axiosInstance
    .get<{
      data: IRoleAssignment | null;
    }>(MyJournalMembershipRoute.build({ ctxId: contextId }))
    .then(r => r.data);
}

export function fetchWorkspaceMemberships({
  workspaceId,
  excludeList = [],
  limit,
  offset,
  filters
}: {
  workspaceId: string;
  excludeList?: string[];
  limit?: number;
  offset?: number;
  filters?: IWorkspaceMembershipFilter;
}) {
  return !workspaceId
    ? { collection: [], total: 0 }
    : axiosInstance
        .get<IListResponse<IWorkspaceMembership>>(
          WorkspaceMembershipsRoute.build({ id: workspaceId }),
          {
            params: {
              excludeList: excludeList.length
                ? excludeList.join(',')
                : undefined,
              limit,
              offset,
              searchParams: filters?.searchParams
            }
          }
        )
        .then(r => r.data);
}

export function fetchSubmissionChecklist(
  submissionId: string,
  submissionContextId: string,
  organizationId: string,
  phase: string,
  articleWorkflowId?: string
) {
  return axiosInstance
    .get<IChecklistResponse>(ChecklistRoute.build({ id: submissionId }), {
      params: {
        submissionContextId,
        organizationId,
        phase,
        articleWorkflowId
      }
    })
    .then(r => r.data);
}

export function fetchActivityLog<T>(
  submissionId: string,
  roleContext: string,
  userId: string,
  SubmissionContextId: string,
  offset: number = 0,
  limit: number = 10,
  sortDirection: 'ascending' | 'descending' = 'ascending',
  filters: {
    eventTypes?: string[];
    eventType?: string;
  }
) {
  return axiosInstance
    .get<{
      total: number;
      results: Array<T>;
      limit: number;
      offset: number;
    }>(
      `submission-contexts/${SubmissionContextId}/submissions/${submissionId}/activity-log`,
      {
        params: {
          roleContext,
          userId,
          limit,
          offset,
          sortDirection,
          types: filters?.eventTypes?.length ? filters.eventTypes : undefined,
          type: filters?.eventType
        },
        paramsSerializer: {
          indexes: null
        }
      }
    )
    .then(res => res.data);
}

export type ISearchByOrganizationNameResponse = {
  organizations: Array<{
    name: string;
    ringgoldId: string;
    topLevelOrganizationName?: string | null;
    organizationType?: string | null;
    formattedLocation?: string | null;
    primaryDomain?: string | null;
    country?: string | null;
    countryCode?: string | null;
    postalCode?: string | null;
  }>;
  totalCount?: number;
};
export function fetchRinggoldOrganization(
  term: string,
  offset: number = 0,
  limit: number = 10
) {
  return axiosInstance
    .get<ISearchByOrganizationNameResponse>(
      '/integrations/ringgold/organization',
      {
        params: {
          term,
          limit,
          offset
        },
        paramsSerializer: {
          indexes: null
        }
      }
    )
    .then(r => r.data);
}

export type ISearchByFunderNameResponse = Array<{
  id: string;
  location: string;
  name: string;
  uri: string;
}>;
export function fetchFunders(term: string) {
  return axiosInstance
    .get<ISearchByFunderNameResponse>('/integrations/funders', {
      params: {
        name: term
      },
      paramsSerializer: {
        indexes: null
      }
    })
    .then(r => r.data);
}

export function fetchSubmissionStateAtEvent(
  submissionId: string,
  params: ISubmissionEventParams
) {
  return axiosInstance
    .get<ISubmission>(`submissions/${submissionId}/states`, { params })
    .then(r => r.data);
}

export const fetchFormDraft = (
  entityId: string,
  entityType: IFormDraftEntityType,
  formType: IFormSchemaName,
  phase?: string
) => {
  return axiosInstance
    .get<IGetFormDraftResponse>(FormDraftRoute.build({ entityId }), {
      params: {
        entityId,
        entityType,
        formType,
        ...(phase && { phase })
      }
    })
    .then(r => r.data);
};

export function fetchSubmissionContextRoleAssignments(
  submissionContextId: string
) {
  return axiosInstance
    .get<IGetSubmissionContextRoleAssignmentsResponse>(
      `/submission-contexts/${submissionContextId}/roles-assignments`
    )
    .then(r => r.data);
}

export function fetchRecommendationAssigneesRole(submissionId: string) {
  return axiosInstance
    .get<IGetSubmissionRecommendationAssigneesResponse>(
      `/submission/${submissionId}/recommendation-assignees`
    )
    .then(r => r.data);
}

export function fetchCocRecommendationSummary(submissionId: string) {
  return axiosInstance
    .get<IGetCOCRecommedationSummaryResponse>(
      `/submission/${submissionId}/coc-recommendation-summary`
    )
    .then(r => r.data);
}

export function fetchSubmissionFields(
  submissionId: string,
  roleType: IRoleType,
  reviewId?: string
) {
  return axiosInstance
    .get<IGetSubmissionFieldsResponse>(
      GetSubmissionFieldsRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType, ...(reviewId && { reviewId }) }
      }
    )
    .then(r => r.data);
}

export function fetchRequestedChangeFields(
  submissionId: string,
  roleType: IRoleType
) {
  return axiosInstance
    .get<IGetSubmissionFieldsResponse>(
      SubmissionRequestedChanges.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

export function fetchSubmissionWorkflow(
  submissionId: string,
  roleType: IRoleType,
  reviewId?: string
) {
  return axiosInstance
    .get<IGetSubmissionWorkflowResponse>(
      `/submission/${submissionId}/workflow`,
      { params: { roleContext: roleType, ...(reviewId && { reviewId }) } }
    )
    .then(r => r.data);
}

export function logSubmissionAceessed(submissionId: string) {
  return axiosInstance
    .get<{ message: string }>(`/submissions/${submissionId}/accessed`)
    .then(r => r.data);
}

export function fetchSubmissionEditorialAssignees(submissionId: string) {
  return axiosInstance
    .get<IGetSubmissionEditorialAssigneesResponse>(
      `/submission/${submissionId}/editorial-assignees`
    )
    .then(r => r.data);
}

export function fetchSubmissionIntegrityReports(submissionId: string) {
  return axiosInstance
    .get<IIntegrityOverviewResponse>(`/check-result/${submissionId}/overview`)
    .then(r => r.data);
}

/**
 * Integrity checks for a submission that is still a draft, as configured for
 * the given role. The list is empty both before a run and when the role has no
 * checks configured, so the caller reads the submission context's
 * `integrityChecks` config to tell the two apart.
 */
export function fetchDraftIntegrityChecks(
  submissionId: string,
  role: IRoleType
) {
  return axiosInstance
    .get<ICustomChecksResponse>(`/check-result/${submissionId}/draft-checks`, {
      params: { role }
    })
    .then(r => r.data);
}

export function fetchVersionLogV2(submissionId: string) {
  return axiosInstance
    .get<SubmissionVersionLogResponse>(
      `/submission/${submissionId}/version-log/v2`
    )
    .then(r => r.data);
}

export function fetchSubmissionExportHistory(
  submissionId: string,
  limit: number,
  offset: number
) {
  return axiosInstance
    .get<IVendorHistoryResponse>(
      `/submission/${submissionId}/vendorExport/history`,
      {
        params: {
          limit,
          offset
        }
      }
    )
    .then(r => r.data);
}

export function testExportConnections(
  exportConfigType: string,
  serverInfo: string
) {
  return axiosInstance
    .get<IVendorExportConnTestResponse>(VendorExportConnectionTest.path, {
      params: {
        exportConfigType,
        serverInfo
      }
    })
    .then(r => r.data);
}

export function getExportHistoryByContext(
  submissionContextId: string,
  orgId: string,
  filters: VendorExportFilters,
  limit: number,
  offset: number
) {
  return axiosInstance
    .get<IVendorHistoryResponse>(
      `/organization/${orgId}/submission-context/${submissionContextId}/vendorExports/history`,
      {
        params: {
          limit,
          offset,
          filters: JSON.stringify(filters ?? {})
        }
      }
    )
    .then(r => r.data);
}

export function fetchSubmissionIntegrityReportsDownload(
  submissionId: string,
  runId: string
) {
  return axiosInstance
    .get<any>(`/check-result/${submissionId}/report/download?runId=${runId}`, {
      responseType: 'arraybuffer'
    })
    .then(r => r);
}

export async function fetchSubmissionDetailedCheckReport(
  submission_id: string,
  checkType: string | undefined,
  runId: string | undefined
) {
  return axiosInstance
    .get<any>(
      `/check-result/${submission_id}/detailed-report?checkType=${checkType}&&runId=${runId}`,
      {
        responseType: 'arraybuffer'
      }
    )
    .then(r => r);
}

export async function fetchDownloadUADReport(submission_id: string) {
  return axiosInstance
    .get<any>(`/submission/${submission_id}/download/uad-reports`, {
      responseType: 'arraybuffer'
    })
    .then(r => r);
}
export async function fetchDownloadEmailVerificationReport(
  submission_id: string
) {
  return axiosInstance
    .get<any>(`/submission/${submission_id}/download/email-status-report`, {
      responseType: 'arraybuffer'
    })
    .then(r => r);
}
export function fetchSubmissionFeedback(submissionId: string) {
  return axiosInstance
    .get<IGetSubmissionFeedbackResponse>(`/submission/${submissionId}/feedback`)
    .then(r => r.data);
}

export function fetchPreProductionFeedback(
  submissionId: string,
  roleType: IRoleType
) {
  return axiosInstance
    .get<IGetPreProductionFeedbackResponse>(
      `/submission/${submissionId}/feedback/preproduction`,
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

export function fetchSubmissionReviewerQueue(
  submissionContextId: string,
  submissionId: string
) {
  return axiosInstance
    .get<Pick<IReviewerInvitation, 'queue'>>(
      `submission-contexts/${submissionContextId}/reviewer-invitations/${submissionId}`,
      { params: { roleContext: 'editor' } }
    )
    .then(r => r.data);
}

export function fetchReviewExtensionDeadline(
  reviewId: string,
  roleContext: 'editor' | 'author' | 'reviewer' | 'expert'
) {
  return axiosInstance
    .get<{
      currentState: string;
      currentDeadline: string;
      nextDeadline: string;
      deadlineExtensionInDays: number;
    }>(`/reviews/${reviewId}/deadline`, { params: { roleContext } })
    .then(r => r.data);
}

export function checkCoReviewerEligibility(reviewId: string, email: string) {
  return axiosInstance
    .post<IReviewerEligibility>(
      `/reviews/${reviewId}/reviewer/check-eligibility`,
      { email }
    )
    .then(r => r.data);
}

export function fetchReviewsSummary(submissionId: string) {
  return axiosInstance
    .get<IGetReviewsSummaryResponse>(
      GetReviewsSummaryRoute.build({ id: submissionId })
    )
    .then(r => r.data);
}

export function fetchSubmittedReviewers(submissionId: string) {
  return axiosInstance
    .get<IGetSubmittedReviewersResponse>(
      GetSubmittedReviewersRoute.build({ id: submissionId })
    )
    .then(response => response.data);
}

export function fetchActiveRevision(
  submissionId: string,
  roleType: IRoleType,
  reviewId?: string
) {
  return axiosInstance
    .get<IGetActiveRevisionResponse>(
      GetActiveRevisionRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType, ...(reviewId && { reviewId }) }
      }
    )
    .then(r => r.data);
}

export const fetchRevisionRoundHistory = (
  submissionId: string,
  roleType: IRoleType
) => {
  return axiosInstance
    .get<IGetRevisionHistoryResponse>(
      GetRevisionHistoryRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
};

export function fetchSubmissionExtensionDeadline(
  submissionId: string,
  roleContext: 'editorial' | 'author'
) {
  return axiosInstance
    .get<IGetExtensionDeadlineResponse>(
      GetSubmissionExtensionDeadlineRoute.build({ id: submissionId }),
      { params: { roleContext } }
    )
    .then(r => r.data);
}

export type ICreateTagResponse = {
  isSuccess: boolean;
  message: string;
};

export function createTag(
  name: string,
  description: string,
  usage: string,
  workspaceId: string
) {
  return axiosInstance
    .post<ICreateTagResponse>(WorkspaceTagsRoute.build({ id: workspaceId }), {
      params: {
        name,
        description,
        usage
      }
    })
    .then(r => r.data);
}

export function getFocusIsuue(ctxId: string) {
  return axiosInstance
    .get<{
      data: FocusIssues[];
      guidelineLink?: string;
    }>(`/submission-contexts/${ctxId}/focus-issues`)
    .then(r => r.data);
}

export function getTransferNetworkConfig(ctxId: string) {
  return axiosInstance
    .get<IGetTransferNetworkConfigResponse>(
      TransferNetworkConfigRoute.build({ ctxId })
    )
    .then(r => r.data);
}

export function getArticleWorkflowSubmissionStates(id: string) {
  return axiosInstance
    .get<IGetArticleWorkflowSubmissionStatesResponse>(
      ArticleWorkflowSubmissionStatesRoute.build({ id })
    )
    .then(r => r.data);
}

export function getSubmissionTransferNetwork(
  submissionId: string,
  roleContext: IRoleType
) {
  return axiosInstance
    .get<IGetSubmissionTransferNetworkResponse>(
      SubmissionTransferNetworkRoute.build({ id: submissionId }),
      { params: { roleContext } }
    )
    .then(r => r.data);
}

export function fetchTransferOffer(submissionId: string, roleType: IRoleType) {
  return axiosInstance
    .get<IGetTransferOfferResponse>(
      GetTransferOfferRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

export function editTag(workspaceId: string, tagId: string) {
  return axiosInstance
    .get<{ count: number }>(WorkspaceTagRoute.build({ id: workspaceId, tagId }))
    .then(r => r.data);
}

export function getMySubmissionFilter() {
  return axiosInstance
    .get<MySubmissionsFilters>(`/my-submissions/filters?limit=999&offset=0`)
    .then(r => r.data);
}

export function fetchMissingFieldsFromArticleId({
  submissionId,
  articleWorkflowId,
  roleContext
}: {
  submissionId: string;
  articleWorkflowId: string;
  roleContext: IRoleType;
}) {
  return axiosInstance
    .get<IGetMissingFieldsFromArticleIdResponse>(
      GetMissingFieldsFromArticleIdRoute.build({
        id: submissionId
      }),
      {
        params: {
          roleContext,
          articleWorkflowId
        }
      }
    )
    .then(r => r.data);
}

export function fetchUserProfileData() {
  return axiosInstance.get<IAuthor>('users/my-profile').then(r => r.data);
}

export function fetchAuthorProfileData(orgId: string, userId: string) {
  return axiosInstance
    .get<IAuthor>(`organizations/${orgId}/workspace-profiles/${userId}`)
    .then(r => r.data);
}

export function fetchReviewerActivity(
  submissionContextId: string,
  userId: string
) {
  return axiosInstance
    .get<IReviewerActivity>(
      `/submission-contexts/reviewer/${submissionContextId}/summary/${userId}`
    )
    .then(r => r.data);
}

export function fetchAuthorEmailLogHistory(
  submissionContextId: string,
  submissionId: string,
  email: string,
  offset: number,
  limit: number
) {
  return axiosInstance
    .get<IEmailLogResponse>(
      `/submission-contexts/${submissionContextId}/submissions/emails/user/${submissionId}/${email}?limit=${limit}&offset=${offset}`
    )
    .then(r => r.data);
}
export function fetchAuthorAuditLogHistory(
  userId: string,
  limit: number,
  offset: number
) {
  return axiosInstance
    .get<IUserProfileAuditLogResponse>(
      `/users/${userId}/audit-log?limit=${limit}&offset=${offset}`
    )
    .then(r => r.data);
}

export function fetchAuthorPublicationHistory(
  workspaceId: string,
  userId: string,
  offset: number,
  limit: number
) {
  return axiosInstance
    .get<IPublicationHistoryDataType>(
      `workspaces/${workspaceId}/workspace-profiles/${userId}/submission-history?limit=${limit}&offset=${offset}`
    )
    .then(r => r.data);
}

export function fetchAuthorReviewData(
  workspaceId: string,
  userId: string,
  offset: number,
  limit: number
) {
  return axiosInstance
    .get<IAuthorReviewType>(
      `workspaces/${workspaceId}/workspace-profiles/${userId}/review-history?limit=${limit}&offset=${offset}`
    )
    .then(r => r.data);
}

export function fetchSubmissionRejection(
  submissionId: string,
  roleType: IRoleType
) {
  return axiosInstance
    .get<IGetSubmissionRejectionResponse>(
      SubmissionRejectionRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

export function fetchSubmissionChangeRequest(
  submissionId: string,
  roleType: IRoleType
) {
  return axiosInstance
    .get<IGetSubmissionChangeRequestResponse>(
      SubmissionChangeRequestRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

export function searchUsers(
  query: string,
  filters?: { organizationId?: string }
) {
  return axiosInstance
    .get<UsersSearchResponse>(UsersSearchRoute.build({}), {
      params: {
        text: query,
        limit: 100,
        offset: 0,
        filters: JSON.stringify(filters ?? {})
      }
    })
    .then(r => r.data);
}

export function searchJournals(
  query: string,
  filters?: { organizationId?: string }
) {
  return axiosInstance
    .get<JournalsSearchResponse>(JournalsSearchRoute.build({}), {
      params: { text: query, filters: JSON.stringify(filters ?? {}) }
    })
    .then(r => r.data);
}

export function listUsers({
  organizationId,
  text = '',
  offset = 0,
  limit = 10,
  submissionContextId
}: {
  organizationId: string;
  text?: string;
  offset?: number;
  limit?: number;
  submissionContextId?: string;
}) {
  return axiosInstance
    .get<UsersListResponse>(UsersListRoute.build({ id: organizationId }), {
      params: { text, offset, limit, submissionContextId }
    })
    .then(r => r.data);
}

export function fetchExperts(name: string, orgId: string) {
  return axiosInstance
    .get<{
      response: IUser[];
    }>(`/organizations/${orgId}/board-members?name=${name}`)
    .then(r => r.data);
}

export function fetchJournalBoardMembers({
  organizationId,
  submissionContextId,
  name = '',
  offset = 0,
  limit = 10
}: {
  organizationId: string;
  submissionContextId: string;
  name?: string;
  offset?: number;
  limit?: number;
}) {
  return axiosInstance
    .get<{
      response: { items: IBoardMemberItem[]; total: number };
    }>(
      `/organization/${organizationId}/submissionContext/${submissionContextId}/board-members`,
      { params: { name, offset, limit } }
    )
    .then(r => r.data);
}

export type ExpertInviteList = {
  completedAssessment: number;
  declinedOrExpired: number;
  inProgress: number;
  items: IEarlyAssessmentListItem[];
  submissionContextId: string;
  total: number;
};
type AdjudicationInviteList = {
  completedAssessment: number;
  declinedOrExpired: number;
  inProgress: number;
  items: IAdjudicationListItem[];
  submissionContextId: string;
  total: number;
};

export function fetchExpertsInviteDetails(
  ctxId: string,
  submissionId: string,
  type: string
) {
  return axiosInstance
    .get<ExpertInviteList>(
      `/submission-contexts/${ctxId}/${type}?submissionId=${submissionId}&roleContext=editor`
    )
    .then(r => r.data);
}
export function fetchAdjudicationInviteDetails(
  ctxId: string,
  submissionId: string,
  type: string,
  offset: number = 0,
  limit: number = 10
) {
  return axiosInstance
    .get<AdjudicationInviteList>(
      `/submission-contexts/${ctxId}/${type}?submissionId=${submissionId}&roleContext=editor`,
      {
        params: {
          offset,
          limit
        }
      }
    )
    .then(r => r.data);
}

// Early assessment api for board member

export function getAssessmentListCount() {
  return axiosInstance
    .get<{
      activeTotal: number;
      completedTotal: number;
    }>(`my-early-assessment/totals`)
    .then(r => r.data);
}

export function fetchAssessmentList(
  offset: number = 0,
  limit: number = 10,
  filters: IEarlyAssessmentListFilters,
  sort?: ISubmissionSortOption
) {
  return axiosInstance
    .get<IPeerReviewManagementListView>(`my-early-assessment`, {
      params: {
        offset,
        limit,
        filters: JSON.stringify(filters ?? {}),
        ...(sort && { sort: JSON.stringify(sort) })
      }
    })
    .then(r => r.data);
}

export function fetchSubmissionWithdrawal(
  submissionId: string,
  roleType: IRoleType
) {
  return axiosInstance
    .get<IGetSubmissionWithdrawalResponse>(
      SubmissionWithdrawalRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

// export function fetchOrgUsers({
//   orgId,
//   limit,
//   offset,
//   filters
// }: {
//   orgId: string;
//   limit?: number;
//   offset?: number;
//   filters?: IWorkspaceUserFilter;
// }) {
//   return axiosInstance
//     .get<IUserListResponse>(`organizations/${orgId}/user-search`, {
//       params: {
//         limit,
//         offset,
//         filters: JSON.stringify(filters ?? {})
//       }
//     })
//     .then(r => r.data);
// }

export function fetchWorkspaceUsers({
  workspaceId,
  limit,
  offset,
  filters
}: {
  workspaceId: string;
  limit?: number;
  offset?: number;
  filters?: IWorkspaceUserFilter;
}) {
  return axiosInstance
    .post<IUserListResponse>(
      `workspaces/${workspaceId}/user-search`,
      {
        journalId: filters?.journalId ?? [],
        tagId: filters?.tagId ?? [],
        role: filters?.role ?? [],
        searchParams: filters?.searchParams ?? '',
        searchFields: filters?.searchFields ?? []
      },
      {
        params: {
          limit,
          offset
        }
      }
    )
    .then(r => r.data);
}

export function fetchWorkspaceMergeAccountSearch({
  workspaceId,
  limit,
  offset,
  filters
}: {
  workspaceId: string;
  limit?: number;
  offset?: number;
  filters?: IMergeAccountSearchFilter;
}) {
  return axiosInstance
    .get<IUserListResponse>(
      WorkspaceMergeAccountSearchRoute.build({ id: workspaceId }),
      {
        params: {
          limit,
          offset,
          filters: JSON.stringify(filters ?? {})
        }
      }
    )
    .then(r => r.data);
}

export function fetchWorkspaceMergeAccountSearchFields(workspaceId: string) {
  return axiosInstance
    .get<{
      items: IMergeAccountSearchField[];
    }>(WorkspaceMergeAccountSearchFieldsRoute.build({ id: workspaceId }))
    .then(r => r.data);
}

export function fetchInvitedWorkspaceUsers({
  workspaceId,
  limit,
  offset,
  filters
}: {
  workspaceId: string;
  limit?: number;
  offset?: number;
  filters?: Pick<IWorkspaceUserFilter, 'searchParams'>;
}) {
  return axiosInstance
    .get<IInvitedUserListResponse>(
      `workspaces/${workspaceId}/invited-user-search`,
      {
        params: {
          limit,
          offset,
          filters: JSON.stringify(filters ?? {})
        }
      }
    )
    .then(r => r.data);
}

export function fetchOrgUserRoles(organizationId: string) {
  return axiosInstance
    .get<IUserRolesResponse>(`organizations/${organizationId}/user-roles`)
    .then(r => r.data);
}

export function fetchSubmissionUnsubmit(
  submissionId: string,
  roleType: IRoleType
) {
  return axiosInstance
    .get<IGetSubmissionUnsubmitResponse>(
      SubmissionUnsubmitRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

export function fetchOrganizationName(
  organizationId: string,
  roleType: IRoleType
) {
  return axiosInstance
    .get<Pick<IOrganization, 'name'>>(
      GetOrganizationNameRoute.build({ id: organizationId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

export function fetchEarlyAssessment(assessmentId: string) {
  return axiosInstance
    .get<any>(`my-early-assessment/${assessmentId}`, {
      params: { roleContext: 'expert' }
    })
    .then(r => r.data);
}

export const fetchEarlyAssessmentFormDraft = (
  entityId: string,
  entityType: IFormDraftEntityType,
  formType: IFormSchemaName,
  phase?: string
) => {
  return axiosInstance
    .get<IGetFormDraftResponse>(`form-drafts/${entityId}`, {
      params: {
        entityId,
        entityType,
        formType,
        ...(phase && { phase })
      }
    })
    .then(r => r.data);
};

export function fetchAssessmentFilters(filterStatus: IAssessmentFilterStatus) {
  return axiosInstance
    .get<IEarlyAssessmentListFiltersResponse>(`my-early-assessment/filters`, {
      params: { status: filterStatus }
    })
    .then(r => r.data);
}

// Adjudications api for board member
export function getAdjudicationListCount() {
  return axiosInstance
    .get<{
      activeTotal: number;
      completedTotal: number;
    }>(`adjudication/totals`)
    .then(r => r.data);
}

export function fetchAdjudicationList(
  offset: number = 0,
  limit: number = 10,
  filters: IAdjudicationsListFilters,
  sort?: ISubmissionSortOption
) {
  return axiosInstance
    .get<IPeerReviewManagementListView>(`adjudication`, {
      params: {
        offset,
        limit,
        filters: JSON.stringify(filters ?? {}),
        ...(sort && { sort: JSON.stringify(sort) })
      }
    })
    .then(r => r.data);
}

export function fetchAdjudicationsFilters(
  filterStatus: IAssessmentFilterStatus
) {
  return axiosInstance
    .get<IAdjudicationsListFiltersResponse>(`adjudication/filters`, {
      params: { status: filterStatus }
    })
    .then(r => r.data);
}

export function fetchAdjudication(adjudicationId: string) {
  return axiosInstance
    .get<IAdjudicationDetailResponse>(`adjudication/${adjudicationId}`, {
      params: { roleContext: 'expert' }
    })
    .then(r => r.data);
}

export function fetchAdjudicationReviews(adjudicationId: string) {
  return axiosInstance
    .get<IAdjudicationReview[]>(`adjudication/${adjudicationId}/reviews`, {
      params: { roleContext: 'expert' }
    })
    .then(r => r.data);
}

export function getJournalBoardMembers(
  ctxId: string,
  { offset = 0, limit = 10 }: { offset?: number; limit?: number } = {}
) {
  return axiosInstance
    .get<{
      response: { items: IBoardMemberItem[]; total: number };
    }>(`/submission-contexts/${ctxId}/board-members`, {
      params: { offset, limit }
    })
    .then(r => r.data);
}

export function fetchCopyrightForm(submissionId: string, roleType: IRoleType) {
  return axiosInstance
    .get<ICopyrightForm>(
      SubmissionCopyrightFormRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

export function fetchSubmittingAuthorOnlyCopyrightForm(
  submissionId: string,
  roleType: IRoleType
) {
  return axiosInstance
    .get<{ authorCopyrightForm: IAuthorCopyrightForm[] }>(
      SubmittingAuthorOnlyCopyrightFormRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
}

export const requestSubmittingAuthorOnlyCopyrightForm = (
  submissionId: string,
  payload: {
    roleContext: string;
    email: string;
    type: string;
  }
) => {
  return axiosInstance
    .post<{}>(
      SubmissionEditorSendCopyrightFormEmailRoute.build({ id: submissionId }),
      {
        ...payload,
        submissionId // include this as per backend contract
      }
    )
    .then(r => r.data);
};

export const fetchICMJEForm = (submissionId: string, roleType: IRoleType) => {
  return axiosInstance
    .get<{ authorICMJEForm: IAuthorICMJEForm[] }>(
      SubmissionAuthorICMJEFormRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
};

export const fetchICMJEFormList = (
  submissionId: string,
  roleType: IRoleType
) => {
  return axiosInstance
    .get<IAuthorICMJEFormList[]>(
      SubmissionAuthorICMJEFormListRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType }
      }
    )
    .then(r => r.data);
};

export const authorSubmitAllICMJEForm = (
  submissionId: string,
  roleType: IRoleType
) => {
  return axiosInstance
    .post(SubmissionAuthorSubmitAllICMJEFormRoute.build({ id: submissionId }), {
      submissionId,
      roleContext: roleType
    })
    .then(r => r.data);
};

export const requestSubmittingAuthorOnlyICMJEForm = (
  submissionId: string,
  payload: {
    roleContext: string;
    email: string;
    type: string;
  }
) => {
  return axiosInstance
    .post<{}>(
      SubmissionEditorSendICMJEFormEmailRoute.build({ id: submissionId }),
      {
        ...payload,
        submissionId // include this as per backend contract
      }
    )
    .then(r => r.data);
};

export const downloadAllICMJEForms = (
  submissionId: string,
  roleType: IRoleType
) => {
  return axiosInstance
    .get<ArrayBuffer>(
      SubmissionEditorDownloadICMJEFormsRoute.build({ id: submissionId }),
      {
        params: { roleContext: roleType },
        responseType: 'arraybuffer'
      }
    )
    .then(r => r.data);
};

export const downloadExportManually = (
  submissionId: string,
  exportType: string,
  submissionContextId: string,
  exportName: string
) => {
  return axiosInstance
    .get<ArrayBuffer>(
      `/submission-context/${submissionContextId}/submission/${submissionId}/vendorExport/download`,
      {
        params: { exportType, exportName },
        responseType: 'arraybuffer'
      }
    )
    .then(r => r.data);
};

export const fetchContentManagementSystemConfig = (
  submissionContextId: string
) => {
  return axiosInstance
    .get<IContentManagementSystem>(
      GetSubmissionContextCMSRoute.build({ id: submissionContextId })
    )
    .then(r => r.data);
};

export function isSubmissionOwner(workspaceId: string, userId: string) {
  return axiosInstance
    .get<boolean>(
      HasOwnedSubmissionInWorkspaceRoute.build({ userId, workspaceId })
    )
    .then(r => r.data);
}

export const fetchWorkspaceMembership = (membershipId: string) =>
  axiosInstance
    .get<IGetWorkspaceMembershipResponse>(
      WorkspaceMembershipRoute.build({ membershipId })
    )
    .then(r => r.data);

export const fetchUserOrganizationWorkspaces = (
  userId: string,
  orgId: string
) =>
  axiosInstance
    .get<IUserOrganizationWorkspacesResponse>(
      UserOrganizationWorkspacesRoute.build({
        id: orgId,
        userId
      })
      // `/organizations/${orgId}/user/${userId}/workspaces`
    )
    .then(r => r.data);

export function fetchUnassignedJournalMemberships({
  workspaceId,
  submissionContextId,
  limit,
  offset,
  searchParams
}: {
  workspaceId: string;
  submissionContextId: string;
  limit?: number;
  offset?: number;
  searchParams?: string;
}) {
  return !workspaceId
    ? { collection: [], total: 0 }
    : axiosInstance
        .get<IListResponse<IWorkspaceMembership>>(
          UnassignedJournalMembershipRoute.build({
            ctxId: submissionContextId
          }),
          {
            params: {
              workspaceId,
              limit,
              offset,
              searchParams
            }
          }
        )
        .then(r => r.data);
}
export interface AffiliationCountryList {
  country: string;
  countryCode: string;
}
export const fetchAffiliationCountryList = () =>
  axiosInstance
    .get<{
      items: AffiliationCountryList[];
      total: number;
    }>(`/affiliation-country-list`)
    .then(r => r.data);

export const fetchReviewerPastReviewHistory = (
  submissionId: string,
  roleContext: string,
  reviewId?: string
) => {
  return axiosInstance
    .get<IPastRevisionHistoryResponse>(
      `submission/${submissionId}/feedback/reviewer-round-history`,
      {
        params: { roleContext, ...(reviewId && { reviewId }) }
      }
    )
    .then(r => r.data);
};

export function fetchEmailByEventId(
  submissionId: string,
  eventId: string,
  roleContext?: IRoleType,
  email?: string,
  reviewId?: string
) {
  return axiosInstance
    .get<{
      total: number;
      items: EmailHistory[];
    }>(
      EventEmailsRoute.build({
        submissionId,
        eventId
      }),
      {
        params: {
          roleContext,
          ...(email && { email }),
          ...(reviewId && { reviewId })
        }
      }
    )
    .then(r => r.data);
}

export type IReviewerSearchProperties = {
  DropDown: boolean;
  datatype: string;
  dispaly: boolean;
  hasConstraints: boolean;
  id: string;
  inverseRelation: string;
  inverseRelationDisplay: string;
  predicateId: string;
  predicateLabel: string;
  displayName: string;
  autosuggest: boolean;
  predicatePrefix: string;
  propertyConstraints: string;
  required: boolean;
  unique: boolean;
  config?: ILexiconField;
};

export type IReviewerSearchPropertyResponse = {
  classColor: string;
  classId: string;
  classLabel: string;
  properties: IReviewerSearchProperties[];
  relations: IReviewerSearchProperties[];
  schemaNamespace: string;
  schemaUri: string;
  updatable: boolean;
};

export type IReviewerSearchPropertiesResponse = {
  journal: IReviewerSearchPropertyResponse[];
  global: IReviewerSearchPropertyResponse[] | null;
};

export const fetchReviewerSearchProperties = (
  ctxId: string,
  projectId: string,
  classId: string
) =>
  axiosInstance
    .get<IReviewerSearchPropertiesResponse>(
      `/submission-contexts/${ctxId}/reviews/${projectId}/lexicon/properties/${classId}`
    )
    .then(r => r.data);

export type ISortOder = 'ASC' | 'DESC';

export interface IGlobalReviewerSearchConfigResponse {
  id: string;
  organizationId: string;
  scope: string;
  fields: ILexiconField[];
  dateFilters: {
    key: string;
    value: string[];
    label: string;
  }[];
  userFilter: {
    key: string;
    label: string;
  }[];
  reviewerActionCard: {
    createAccount: boolean;
  };
  _id: string;
  created_at: string;
  modified_at: string;
  __v: number;
}

export const fetchGlobalReviewerSearchConfig = (organizationId: string) =>
  axiosInstance
    .get<IGlobalReviewerSearchConfigResponse>(
      `/global-reviewer-search-config/${organizationId}`
    )
    .then(r => r.data);

export type ISortType = {
  key: string;
  order: ISortOder;
  id: string | undefined;
  datatype: string;
};

export type ISearchCriteria = {
  id: string;
  value: string[];
  operator: 'AND' | 'OR';
  datatype: string;
};

export type IDynamicFilters = {
  schemaId: string;
  datatype: 'xsd:boolean' | 'xsd:string';
  values: string[];
};

export type IFilters = {
  classFilter: string[];
};

export type ISearchQueryProperty = {
  propertyBoolean: boolean;
  propertyDatatype: string;
  propertyDate: string;
  propertyDouble: string;
  propertyName: string;
  propertySource: string;
  propertyPrefix: string;
  propertyValueString: string[];
  propertyValueInt: string;
  schemaId: string;
};

export type ISearchQueryItems = {
  classId: string;
  classLabel: string;
  classPrefix: string;
  classColour: string;
  conceptId: string;
  createdBy: string;
  createdByName: string;
  createdOn: string;
  ontologyId: string;
  projectId: string;
  status: string;
  name: string;
  updatedBy: string;
  updatedByName: string;
  updatedOn: string;
  version: string;
  properties: ISearchQueryProperty[];
  error: IReviewerCOIItem[];
  warning: IReviewerCOIItem[];
  info: IReviewerCOIItem[];
  isAllowed: boolean;
  total: number;
  size: number;
  globalReviewer: ISearchQueryProperty[];
};

export type ISearchQueryParams = {
  ctxId: string;
  projectId: string;
  start: number;
  size: number;
  sortType: ISortType;
  searchCriteria: ISearchCriteria[];
  dynamicFilters: IDynamicFilters[];
  filters: IFilters;
  fuzzy?: boolean;
  dateFilter?: {
    startDate: string;
    endDate: string;
  };
  submissionId: string;
  globalFilters?: {
    searchCriteria: ISearchCriteria[];
    dynamicFilters: IDynamicFilters[];
  };
};

export type IFacets = {
  classId: string;
  classLabel: string;
  classColor: string;
  classPrefix: string;
  docCount: string;
};

export type ISearchQueryFacets = {
  type: string;
  facets: IFacets[];
};

export interface IPropertyFacetValue {
  key: string;
  count: string;
}

export interface IPropertyFacet {
  schemaId: string;
  propertyName: string;
  propertyPrefix: string;
  classPrefix: string;
  classLabel: string;
  datatype: string;
  values: IPropertyFacetValue[];
}

export interface IPropertyFacetGroup {
  type: string;
  facets: IPropertyFacet[];
}

export type ISearchQueryResponse = {
  items: ISearchQueryItems[];
  total: number;
  size: number;
  facets: ISearchQueryFacets[];
  staticFacets: ISearchQueryFacets[];
  propertyFacets: IPropertyFacetGroup[];
};

export const fetchSearchQueryResults = ({
  ctxId,
  projectId,
  start,
  size,
  sortType,
  searchCriteria,
  dynamicFilters,
  filters,
  fuzzy,
  dateFilter,
  submissionId,
  globalFilters
}: ISearchQueryParams) => {
  const searchFilters = {
    start,
    size,
    sortType,
    searchCriteria,
    dynamicFilters,
    filters,
    fuzzy,
    ...(dateFilter ? { dateFilter } : {})
  };
  return axiosInstance
    .post<ISearchQueryResponse>(
      `/submission-contexts/${ctxId}/reviews/${projectId}/lexicon/search`,
      {
        filters: {
          ...searchFilters,
          submissionId
        },
        ...(globalFilters ? { globalFilters } : {})
      }
    )
    .then(r => r.data);
};

export type IAutoSuggestParams = {
  ctxId: string;
  projectId: string;
  schemaID: string;
  value: string;
};

export type IAutoSuggestResponse = {
  items: string[];
  total: number;
  size: number;
};

export const fetchReviewerSearchAutoSuggestValues = ({
  ctxId,
  projectId,
  schemaID,
  value
}: IAutoSuggestParams) => {
  return axiosInstance
    .get<IAutoSuggestResponse>(
      `/submission-contexts/${ctxId}/reviews/${projectId}/lexicon/names`,
      { params: { schemaID, value } }
    )
    .then(r => r.data);
};

export type IEnsureReviewerInfoForAuthor = {
  reviewerEmail?: string;
  affiliation?: string;
};

export type IEnsureReviewerParamsForAuthor = {
  ctxId: string;
  projectId: string;
  draftId: string;
  reviewers: IEnsureReviewerInfoForAuthor[];
  type: 'draft' | 'submission';
};

export type IEnsureReviewerResults = {
  reason: string;
  reviewerEmail: string;
  status: 'valid' | 'invalid';
  affiliation?: string;
  percentageMatching?: number;
};

export type IEnsureReviewerResponse = {
  message: string;
  results: IEnsureReviewerResults[];
  submissionId: string;
};

export interface IMyRecentActivityResponse {
  workspace: IWorkspace;
  isWorkspaceMember: boolean;
  recentActivity: IRecentActivityJournal[];
}

export interface IRecentActivityJournal {
  journal: {
    id: string;
    name: string;
    shortname: string;
    roles: string[];
  };
  roleWiseActivity: IRoleWiseActivity[];
}

export interface IRoleWiseActivity {
  role: string;
  activity: IActivityItem[];
}

export interface IActivityItem {
  _id: string;
  submissionId: string;
  manuscriptId: string;
  submissionTitle: string;
  submissionType: string;
  event: {
    type: string;
    date: string;
    reviewRequestId?: string;
    subtype?: string;
  };
  authors: Array<{
    firstName?: string;
    lastName?: string;
  }>;
}

export const postEnsureReviewerForAuthor = ({
  ctxId,
  projectId,
  draftId,
  reviewers,
  type
}: IEnsureReviewerParamsForAuthor) => {
  return axiosInstance
    .post<IEnsureReviewerResponse>(
      `/submission-contexts/${ctxId}/reviews/${projectId}/authors/ensure-reviewer`,
      {
        draftId,
        reviewers,
        type
      }
    )
    .then(r => r.data);
};

export function validatorForAddReviewer(
  submissionContextId: string,
  submissionId: string,
  emails: string[]
) {
  return axiosInstance
    .post<IReviewerCOI[]>(
      `/submission-contexts/${submissionContextId}/contexts/reviewers/check`,
      {
        submissionId,
        emails
      }
    )
    .then(r => r.data);
}

export type IReviewerRecommendationResponse = {
  submissionId: string;
  reviewers: IReviewerSuggestion[];
  total?: number;
  offset?: number;
  limit?: number;
  updatedAt?: string;
};

export const fetchReviewerRecommendations = (params: {
  submissionContextId: string;
  submissionId: string;
  provider: RecommendationProvider;
  offset?: number;
  limit?: number;
  filters?: Record<string, string>;
  sort?: {
    value: 'firstName' | 'lastName' | 'score';
    direction: 'asc' | 'desc';
  };
  isReload?: boolean;
}) =>
  axiosInstance
    .post<IReviewerRecommendationResponse>(
      `/submission-contexts/${params.submissionContextId}/reviews/recommendations/provider/${params.provider}`,
      { submissionId: params.submissionId, filters: params.filters },
      {
        params: {
          offset: params.offset,
          limit: params.limit,
          sort: params.sort ? JSON.stringify(params.sort) : undefined,
          isReload: params.isReload ? 'true' : false
        }
      }
    )
    .then(r => r.data);

export function fetchAdjudicatorReviewsSummary(submissionId: string) {
  return axiosInstance
    .get<IAdjudicatorFeedback[]>(
      GetAdjudicationsSummaryRoute.build({ id: submissionId })
    )
    .then(r => r.data);
}

export function fetchArticleTypesCompatibility(submissionId: string) {
  return axiosInstance
    .get<ISubmissionArticleTypesCompatibilityRouteResponse>(
      SubmissionArticleTypesCompatibilityRoute.build({ id: submissionId })
    )
    .then(r => r.data);
}

export function fetchHasCompletedReviews(
  submissionId: string,
  submissionState: string
) {
  return axiosInstance
    .get<boolean>(HasCompletedReviewsRoute.build({ id: submissionId }), {
      params: {
        submissionState
      }
    })
    .then(r => r.data);
}

export type ISubmissionSortOption = {
  value: string;
  label: string;
  direction: 'asc' | 'desc';
};

type SubmissionResponse<T> = {
  total: number;
  items: T[];
};

export function fetchSubmissions<T>({
  submissionType,
  limit,
  offset,
  filters,
  sort
}: {
  submissionType: string;
  limit?: number;
  offset?: number;
  filters?: IMySubmissionFilter;
  sort?: ISubmissionSortOption;
}): Promise<SubmissionResponse<T>> {
  return axiosInstance
    .get<SubmissionResponse<T>>('/dashboard/my-submissions', {
      params: {
        submissionType,
        limit,
        offset,
        filters: JSON.stringify(filters ?? {}),
        ...(sort && { sort: JSON.stringify(sort) })
      }
    })
    .then(r => r.data);
}

export function fetchMySubmissionsTotals(): Promise<IMySubmissionsTotals> {
  return axiosInstance
    .get<IMySubmissionsTotals>(DashboardMySubmissionsTotalsRoute.path)
    .then(r => r.data);
}

export function fetchSubmissionsDashBoardConfig({
  workspaceId,
  view,
  submissionContextId
}: {
  workspaceId?: string;
  view: string;
  submissionContextId?: string;
}) {
  return axiosInstance
    .get<IDashboardSubmissionConfigResponse>('/dashboard/submission/configs', {
      params: {
        workspaceId,
        view,
        submissionContextId
      }
    })
    .then(r => r.data);
}

export function fetchAdjudicationsDashBoardConfig({
  workspaceId,
  view
}: {
  workspaceId?: string;
  view: string;
}) {
  return axiosInstance
    .get<IAdjudicationsDashBoardConfigResponse>(
      '/dashboard/submission/configs',
      {
        params: {
          workspaceId,
          view
        }
      }
    )
    .then(r => r.data);
}
export function fetchAssessmentDashBoardConfig({
  workspaceId,
  view
}: {
  workspaceId?: string;
  view: string;
}) {
  return axiosInstance
    .get<IAssessmentDashBoardConfigResponse>('/dashboard/submission/configs', {
      params: {
        workspaceId,
        view
      }
    })
    .then(r => r.data);
}

export function fetchSavedFiltersByView(view: string) {
  return axiosInstance
    .get<{ response: ISavedFilters[] }>('/dashboard/saved-filters', {
      params: {
        view
      }
    })
    .then(r => r.data);
}

export function fetchWorkFlowDetails(journalId: string) {
  return axiosInstance
    .get<WorkspaceWorkflowResponse>(`workspace/${journalId}/workflow`)
    .then(r => r.data);
}

export function validateAdjudicatorEligibility(
  submissionId: string,
  emails: string[]
) {
  return axiosInstance
    .post<IAdjudicatorEligibility[]>(
      AdjudicatorEligibilityRoute.build({ id: submissionId }),
      {
        emails
      }
    )
    .then(r => r.data);
}

export function fetchUserProfileDetails() {
  return axiosInstance
    .get<{ data: IUserDetailsResponse }>('users/profile-details')
    .then(r => r.data);
}

export interface IReviewerFilterItem {
  value: string;
  name: string;
}

export interface IReviewerFilterConfig {
  key: string;
  label: string;
  items: IReviewerFilterItem[];
}

export interface IReviewerConfigResponse {
  filters: IReviewerFilterConfig[];
  sortOptions: {
    fields: {
      value: string;
      label: string;
      direction: 'asc' | 'desc';
    }[];
  };
  cards: unknown[];
  meta: {
    view: 'peer-reviews' | string;
  };
}

export function fetchReviewerStatus() {
  return axiosInstance.get<IReviewerConfigResponse>(
    '/dashboard/submission/configs?view=peer-reviews'
  );
}

export function fetchMyRecentActivity(authRealm: string, userId: string) {
  return axiosInstance
    .get<IMyRecentActivityResponse>(
      `/organizations/${authRealm}/my-recent-activity/${userId}`
    )
    .then(r => r.data);
}

export const fetchOverviewDetails = (submissionId: string, ctxId: string) => {
  return axiosInstance
    .get<IManuscriptOverviewResponse>(
      `submission/${submissionId}/${ctxId}/overview-details`
    )
    .then(r => r.data);
};

export function fetchReviewInvitationPreview(reviewId: string, email: string) {
  return axiosInstance
    .get<{
      results: IEmailLog[];
    }>(`submission-contexts/emails/${reviewId}/${email}`)
    .then(r => r.data);
}

export function fetchNotificationWebhookEvents(
  params: IProcessedWebhookEventsQuery
) {
  const serializeArrayParam = (value?: string[] | string) =>
    Array.isArray(value) ? JSON.stringify(value) : value;

  return axiosInstance
    .get<IProcessedWebhookEventsResponse>(
      '/notification-manager/webhook/events',
      {
        params: {
          ...params,
          eventTypes: serializeArrayParam(params.eventTypes),
          reason: serializeArrayParam(params.reason),
          status: serializeArrayParam(params.status),
          submissionContextId: serializeArrayParam(params.submissionContextId),
          sort: params.sort ? JSON.stringify(params.sort) : undefined
        }
      }
    )
    .then(r => r.data);
}

export function exportNotificationWebhookEvents(
  params: IProcessedWebhookEventsQuery
) {
  const serializeArrayParam = (value?: string[] | string) =>
    Array.isArray(value) ? JSON.stringify(value) : value;

  return axiosInstance.get<ArrayBuffer>(
    '/notification-manager/webhook/events/export',
    {
      params: {
        ...params,
        eventTypes: serializeArrayParam(params.eventTypes),
        reason: serializeArrayParam(params.reason),
        status: serializeArrayParam(params.status),
        submissionContextId: serializeArrayParam(params.submissionContextId),
        sort: params.sort ? JSON.stringify(params.sort) : undefined
      },
      responseType: 'arraybuffer'
    }
  );
}

export function fetchEmailHistoryList(params: IEmailHistoryListQuery) {
  return axiosInstance
    .post<IEmailHistoryListResponse>('/email-history/list', params)
    .then(r => r.data);
}

export function fetchEmailTrackerData(trackerId: string) {
  return axiosInstance
    .get<IEmailTrackerResponse>(`/email-history/tracker/${trackerId}`)
    .then(r => r.data.data);
}

export function fetchNotificationWebhookEvent(id: string) {
  return axiosInstance
    .get<IProcessedWebhookEventDetailsResponse>(
      `/notification-manager/webhook/event/${id}`
    )
    .then(r => r.data);
}

export function fetchTagCategories(
  workspaceId: string,
  offset: number = 0,
  limit: number = 999
) {
  return axiosInstance
    .get<{
      collection: ITagCategoryList[];
      total: number;
    }>(`/workspaces/${workspaceId}/categories?offset=${offset}&limit=${limit}`)
    .then(r => r.data);
}

export function getBaseJournalId(orgId: string) {
  return axiosInstance
    .get<{
      submissionContextId: string;
    }>(`/organizations/${orgId}/base-journal`)
    .then(r => r.data);
}

export function getAllFieldsSchema(orgId: string) {
  return axiosInstance
    .get<{
      fields: Record<string, FormFieldDefinition>;
    }>(`/organizations/${orgId}/base-document-schema`)
    .then(r => r.data);
}

export function getDocumentSchema(
  articleTypeId: string,
  submissionContextId: string
) {
  return axiosInstance
    .get<{
      documentSchema: IFormSchema;
    }>(
      `/submission-contexts/${submissionContextId}/article-types/${articleTypeId}/document-schema`
    )
    .then(r => r.data);
}

export function checkArticleTypeHasSubmissions(
  orgId: string,
  articleTypeId: string
) {
  return axiosInstance
    .get<{
      hasSubmissions: boolean;
    }>(`/organizations/${orgId}/article-types/${articleTypeId}/has-submissions`)
    .then(r => r.data);
}

export function fetchContactUsCategories() {
  return axiosInstance
    .get<{ data: string[] }>(ContactUsConfigRoute.path)
    .then(r => r.data);
}

export function fetchContactUsUnauthenticatedCategories() {
  return axiosInstance
    .get<{ data: string[] }>(ContactUsUnauthenticatedConfigRoute.path)
    .then(r => r.data);
}

export function fetchAllUADReports(submissionId: string) {
  return axiosInstance
    .get<IUADReportResponse>(`/submission/${submissionId}/uad-reports`)
    .then(r => r.data);
}
export function fetchAllSubmissionParticipantsEmails(submissionId: string) {
  return axiosInstance
    .get<ISubmissionParticipantsResponse>(
      `/submission/${submissionId}/participants-email-status`
    )
    .then(r => r.data);
}
export function fetchTransferOverviewDetails(
  submissionId: string,
  manuscriptId: string
) {
  return axiosInstance
    .get<IManuscriptOverviewResponse>(
      `/submission/${submissionId}/${manuscriptId}/transfer-overview-details`
    )
    .then(r => r.data);
}
export function fetchWorkspaceInActiveJournals(
  workspaceId: string,
  offset?: number,
  limit?: number,
  isActive: boolean = false,
  searchParams?: string
) {
  return axiosInstance
    .get<ISubmissionContextListView>(
      WorkspaceJournalsRoute.build({ id: workspaceId }),
      {
        params: {
          limit,
          offset,
          isActive: isActive,
          ...(searchParams?.trim() ? { searchParams: searchParams.trim() } : {})
        }
      }
    )
    .then(r => r.data);
}

export function fetchSubmissionReviewsSummary(
  submissionContextId: string,
  submissionId: string
) {
  return axiosInstance
    .get<IPeerReviewHighlightsCountsResponse>(
      `submission-contexts/${submissionContextId}/reviews/highlights-counts`,
      {
        params: {
          submissionId,
          roleContext: 'editor'
        }
      }
    )
    .then(r => r.data);
}

export function fetchJournalConfiguredBuckets(ctxId: string) {
  return axiosInstance
    .get<
      Array<{
        role: string;
        buckets: WorkflowBucket[];
      }>
    >(JournalConfigurationBucketsRoute.build({ ctxId }))
    .then(r => r.data);
}
export function fetchDefaultBucketsForRole(ctxId: string, role: string) {
  return axiosInstance
    .get<{
      role: string;
      buckets: WorkflowBucket[];
    }>(JournalConfigurationDefaultBucketsRoute.build({ ctxId }), {
      params: { role }
    })
    .then(r => r.data);
}

/** This Default checklists API Used in future. */
// export function fetchDefaultChecklist(ctxId: string) {
//   return axiosInstance
//     .get<{ editorialFormSchemas: IEditorialFormSchema[] }>(
//       JournalConfigurationDefaultChecklistRoute.build({ ctxId })
//     )
//     .then(r => r.data);
// }

export function fetchJournalConfiguredChecklists(
  ctxId: string,
  articleWorkflowId: string
) {
  return axiosInstance
    .get<{
      editorialFormSchemas: IEditorialFormSchema[];
    }>(JournalConfigurationArticleChecklistRoute.build({ ctxId }), {
      params: { articleWorkflowId }
    })
    .then(r => r.data);
}

export function fetchJournalConfiguredResponseTemplates(
  ctxId: string,
  templateType: string
) {
  return axiosInstance
    .get<{
      decisions: Array<{
        type: string;
        label: string;
        description: string;
        subtypes: Array<{
          label: string;
          type: string;
        }>;
      }>;
    }>(
      JournalConfigurationDefaultDecisionTemplateOptionsRoute.build({ ctxId }),
      {
        params: { templateType }
      }
    )
    .then(r => r.data);
}

export function fetchJournalConfiguredDecisionTemplates(
  ctxId: string,
  templateType: string
) {
  return axiosInstance
    .get<{
      decisionTemplates: Array<{
        type: string;
        label?: string;
        templates?: Array<{
          templateId: string;
          text: string;
          label: string;
          type: string;
          subtype?: string;
          templateType: string;
        }>;
        subtypes?: Array<{
          subtype?: string;
          label?: string;
          templates: Array<{
            templateId: string;
            text: string;
            label: string;
            type: string;
            subtype?: string;
            templateType: string;
          }>;
        }>;
      }>;
    }>(JournalConfigurationDecisionTemplatesRoute.build({ ctxId }), {
      params: { templateType }
    })
    .then(r => r.data);
}

export function fetchSubmissionDecisionTemplatesByType(
  submissionId: string,
  type: string,
  templateType: string
) {
  return axiosInstance
    .get<IDecisionTemplatesByTypeResponse>(
      SubmissionDecisionTemplatesByTypeRoute.build({ id: submissionId }),
      {
        params: {
          type,
          templateType
        }
      }
    )
    .then(r => r.data);
}

export function fetchAllPageHelpContent(search?: string) {
  return axiosInstance
    .get<IPageHelpContentResponse[]>(PageHelpRoute.path, {
      params: {
        search
      }
    })
    .then(r => r.data);
}
export function fetchPageHelpContent(pageName: string) {
  return axiosInstance
    .get<IPageHelpContent>(PageHelpCreateRoute.build({ pageName: pageName }))
    .then(r => r.data);
}
export function fetchPageHelpTopic(
  pageName: string,
  topicId: string,
  search: string | undefined
) {
  return axiosInstance
    .get<IGetTopicResponse>(
      PageHelpTopicRoute.build({
        pageName: pageName,
        topicId: topicId
      }),
      {
        params: {
          search
        }
      }
    )
    .then(r => r.data);
}
export function fetchHelpVideo(
  pageName: string,
  topicId: string,
  videoId: string
) {
  return axiosInstance
    .get<IGetVideoResponse>(
      PageHelpPlayVideoRoute.build({
        pageName: pageName,
        topicId: topicId
      }),
      {
        params: {
          videoId: videoId
        }
      }
    )
    .then(r => r.data);
}

export function fetchAllPageHelpContentUnauthenticated(search?: string) {
  return axiosInstance
    .get<IPageHelpContentResponse[]>(`/users${PageHelpRoute.path}`, {
      params: {
        search
      }
    })
    .then(r => r.data);
}
export function fetchPageHelpContentUnauthenticated(pageName: string) {
  return axiosInstance
    .get<IPageHelpContent>(
      `/users${PageHelpCreateRoute.build({ pageName: pageName })}`
    )
    .then(r => r.data);
}
export function fetchPageHelpTopicUnauthenticated(
  pageName: string,
  topicId: string,
  search: string | undefined
) {
  return axiosInstance
    .get<IGetTopicResponse>(
      `/users${PageHelpTopicRoute.build({
        pageName: pageName,
        topicId: topicId
      })}`,
      {
        params: {
          search
        }
      }
    )
    .then(r => r.data);
}
export function fetchHelpVideoUnauthenticated(
  pageName: string,
  topicId: string,
  videoId: string
) {
  return axiosInstance
    .get<IGetVideoResponse>(
      `/users${PageHelpPlayVideoRoute.build({
        pageName: pageName,
        topicId: topicId
      })}`,
      {
        params: {
          videoId: videoId
        }
      }
    )
    .then(r => r.data);
}
